// Copyright (c) 2017 Deere & Company

import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateAdjustmentTypes = (state, action) =>
    KeyValuePairCollection.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().adjustmentTypes, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_PARTIAL_DEBIT_ADJUSTMENT_TYPE_COLLECTION]: updateAdjustmentTypes
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/reducers/adjustment-types.js